import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../api-config/axios";

export const loginUser = createAsyncThunk("user/login", async (params) => {
  const res = await api.post("/api/v1/auth/login", {
    ...params,
  });
  return res.data;
});

export const registerUser = createAsyncThunk(
  "user/register",
  async (params) => {
    const res = await api.post("/api/v1/auth/register", {
      ...params,
    });
    return res.data;
  }
);

export const getUser = createAsyncThunk("user/getuser", async (userId) => {
  const res = await api.get(`/api/v1/users/${userId}`);
  return res.data;
});

export const subscribeTrack = createAsyncThunk(
  "subscribeTrack/post",
  async (params) => {
    const { trackId, paymentGetway } = params;
    const res = await api.post(`/api/v1/tracks/${trackId}/subscribe`, {
      paymentGetway,
    });
    return res.data;
  }
);
